import { Modal, inputCls, btnPrimary } from "../bits";
import { API } from "../../lib/api";

export function StaffFormModal({ open, mode, member, onClose, form, setForm, certFile, setCertFile, busy, onSave }) {
  return (
    <Modal open={open} onClose={onClose}
      title={mode === "edit" ? "تعديل بيانات الموظف" : "إضافة موظف متطوع"} testid="staff-form-modal">
      <div className="space-y-3">
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">الاسم الرباعي *</label>
          <input data-testid="staff-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} placeholder="عبدالعزيز سعد محمد الحربي" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">عدد الساعات التطوعية (تُحسب تلقائياً من مشاركات الفرص أيضاً)</label>
          <input data-testid="staff-hours-field" type="number" min="0" value={form.hours}
            onChange={(e) => setForm({ ...form, hours: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">المسمى الوظيفي</label>
          <input data-testid="staff-job-title-input" value={form.job_title || ""} onChange={(e) => setForm({ ...form, job_title: e.target.value })} className={inputCls} placeholder="معلم / وكيل / إداري" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">الفئة</label>
          <select data-testid="staff-category-select" value={form.category || ""} onChange={(e) => setForm({ ...form, category: e.target.value })} className={inputCls}>
            <option value="">— غير مصنّف —</option>
            <option value="معلمون">المعلمون</option>
            <option value="إداريون">الإداريون</option>
            <option value="خارجيون">متطوعون خارجيون (من خارج المدرسة)</option>
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">ساعات المتابعة (منصة التطوع الوطنية)</label>
          <input data-testid="staff-national-hours-input" type="number" min="0" value={form.national_hours || 0}
            onChange={(e) => setForm({ ...form, national_hours: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">صورة شهادة المتطوع بالساعات من منصة التطوع (اختياري)</label>
          <input data-testid="staff-cert-input" type="file" accept="image/*,application/pdf" className={inputCls}
            onChange={(e) => setCertFile(e.target.files?.[0] || null)} />
          {member?.certificate && (
            <a data-testid="staff-cert-view" target="_blank" rel="noreferrer"
              href={`${API}/portal/staff/${member.id}/certificate`}
              className="text-[11px] font-bold text-turq-600 hover:text-turq-900 mt-1 inline-block">عرض الشهادة الحالية</a>
          )}
        </div>
        <button data-testid="staff-save-btn" onClick={onSave} disabled={busy} className={`${btnPrimary} w-full justify-center`}>
          {busy ? "جارٍ الحفظ …" : "حفظ"}
        </button>
      </div>
    </Modal>
  );
}
